import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-213a2029")

_pushScopeId("data-v-213a2029")
const _hoisted_1 = { class: "video-button" }
const _hoisted_2 = { class: "wrap-video" }
const _hoisted_3 = { class: "wrap-button" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TitleOption = _resolveComponent("TitleOption")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_Button = _resolveComponent("Button")
  const _component_PopUpWithChevron = _resolveComponent("PopUpWithChevron")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithChevron, {
      class: "video",
      name: _ctx.iconCamName,
      disabled: _ctx.disabled,
      size: "25px",
      "tooltip-btn": _ctx.camTooltip,
      "tooltip-chevron": _ctx.t('buttons.cameraSettings'),
      "onUpdate:media": _ctx.toggleVideo
    }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_ctx.listCamera.length)
            ? (_openBlock(), _createBlock(_component_TitleOption, {
                key: 0,
                class: "title",
                title: _ctx.t('buttons.selectCamera')
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listCamera, (item) => {
            return (_openBlock(), _createBlock(_component_RadioInput, {
              class: "item",
              item: item.label,
              checked: _ctx.isActive(item),
              onChange: ($event: any) => (_ctx.updateVideoDevice(item)),
              name: "camera"
            }, null, 8, ["item", "checked", "onChange"]))
          }), 256))
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            class: "btn-video-setting",
            mode: "flat",
            size: "l",
            onClick: _ctx.showVideoSettings
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('buttons.videoSettings')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["name", "disabled", "tooltip-btn", "tooltip-chevron", "onUpdate:media"])
  ]))
})